import {
    fetchNumberOfActivePlayersSaga,
    fetchNumberOfEventsForTheLastDaySaga,
    fetchNumberOfPlayersSaga,
    fetchNumberOfPlayersWithOpenAlertsSaga,
    fetchOpenAlertsPerRuleCategorySaga,
    fetchOverallSystemRiskSaga,
    fetchRegistrationsPerMonthSaga,
    fetchStatsSaga,
    fetchTopRiskyPlayersSaga,
    fetchWorldmapSaga
} from '../../main/main-content/dashboard/redux/sagas';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
    FETCH_CLIENT_CREDENTIALS,
    SET_CLIENT_BRANDS
} from '../../main/main-content/client-access/redux/actionTypes';
import {
    fetchClientCredentialsSaga,
    setClientBrandsSaga
} from '../../main/main-content/client-access/redux/sagas';
import {
    FETCH_AUDIT_EVENTS,
    FETCH_AUDIT_USERS
} from '../../main/main-content/audit/redux/actionTypes';
import {
    fetchAuditEventsSaga,
    fetchAuditUsersSaga
} from '../../main/main-content/audit/redux/sagas';
import {
    CREATE_WORKSPACE,
    DELETE_WORKSPACE,
    FETCH_WORKSPACES,
    REFRESH_WORKSPACE,
    RESET_WORKSPACE
} from '../../main/main-content/simulation/redux/workspaces/actionTypes';
import {
    createWorkspaceSaga,
    deleteWorkspaceSaga,
    fetchWorkspacesSaga,
    refreshWorkspaceSaga,
    resetWorkspaceSaga
} from '../../main/main-content/simulation/redux/workspaces/sagas';
import {
    CANCEL_RUN,
    CREATE_RUN,
    DELETE_RUN,
    FETCH_RUN_TO_COPY,
    FETCH_RUNS,
    FETCH_SCENARIOS,
    FETCH_SIMULATION_LIMITS,
    FOLLOW_RUN,
    FOLLOW_RUNS_LIST
} from '../../main/main-content/simulation/redux/runs/actionTypes';
import {
    cancelRunSaga,
    createRunSaga,
    deleteRunSaga,
    fetchRunsSaga,
    fetchRunToCopySaga,
    fetchScenariosSaga,
    fetchSimulationLimitsSaga,
    watchFollowRunSaga,
    watchFollowRunsListSaga
} from '../../main/main-content/simulation/redux/runs/sagas';
import {
    FETCH_COMPARISON,
    FETCH_WORKSPACE_CONFIG,
    FOLLOW_COMPARISON,
    START_COMPARISON
} from '../../main/main-content/simulation/redux/comparison/actionTypes';
import {
    fetchComparisonSaga,
    fetchWorkspaceConfigSaga,
    startComparisonSaga,
    watchFollowComparisonSaga
} from '../../main/main-content/simulation/redux/comparison/sagas';
import { fetchAlertsSaga } from '../../main/main-content/alerts/list/redux/sagas';
import { dismissAlertSaga } from '../../main/main-content/alerts/dismiss/redux/sagas';
import {
    fetchRulesSaga,
    updateRuleSaga,
    updateRuleStatusSaga
} from '../../main/main-content/modify-rules/redux/sagas';
import { fetchEventsSaga } from '../../main/main-content/risk-assessment/redux/events/sagas';
import {
    fetchRiskConfigSaga,
    updateRiskConfigSaga
} from '../../main/main-content/risk-assessment/redux/risk/sagas';
import { fetchPlayersSaga } from '../../main/main-content/players/redux/sagas';
import {
    fetchPlayerAlertsSaga,
    fetchPlayerDetailsSaga,
    fetchPlayerEventsSaga
} from '../../main/main-content/players/player-details/content/redux/sagas';
import {
    fetchUserPermissionsSaga,
    loginSaga
} from '../../auth/login/redux/sagas';
import {
    setToastErrorSaga,
    setToastSuccessSaga
} from '../../shared/toast/redux/sagas';
import {
    FETCH_USER_PERMISSIONS,
    LOGIN
} from '../../auth/login/redux/actionTypes';
import {
    FETCH_NUMBER_OF_ACTIVE_PLAYERS,
    FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY,
    FETCH_NUMBER_OF_PLAYERS,
    FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS,
    FETCH_OPEN_ALERTS_PER_RULE_CATEGORY,
    FETCH_OVERALL_SYSTEM_RISK,
    FETCH_REGISTRATIONS_PER_MONTH,
    FETCH_STATS,
    FETCH_TOP_RISKY_PLAYERS,
    FETCH_WORLDMAP
} from '../../main/main-content/dashboard/redux/actionTypes';
import { FETCH_ALERTS } from '../../main/main-content/alerts/list/redux/actionTypes';
import { DISMISS_ALERT } from '../../main/main-content/alerts/dismiss/redux/actionTypes';
import {
    FETCH_RULES,
    UPDATE_RULE,
    UPDATE_RULE_STATUS
} from '../../main/main-content/modify-rules/redux/actionTypes';
import { FETCH_EVENTS } from '../../main/main-content/risk-assessment/redux/events/actionTypes';
import {
    FETCH_RISK_CONFIG,
    UPDATE_RISK_CONFIG
} from '../../main/main-content/risk-assessment/redux/risk/actionTypes';
import { FETCH_PLAYERS } from '../../main/main-content/players/redux/actionTypes';
import {
    FETCH_PLAYER_ALERTS,
    FETCH_PLAYER_DETAILS,
    FETCH_PLAYER_EVENTS
} from '../../main/main-content/players/player-details/content/redux/actionTypes';
import {
    SET_TOAST_ERROR,
    SET_TOAST_SUCCESS
} from '../../shared/toast/redux/actionTypes';
import {
    fetchJurisdictionsSaga,
    setJurisdictionByCodeSaga,
    setJurisdictionSaga
} from '../../jurisdiction/redux/sagas';
import {
    FETCH_JURISDICTIONS,
    SET_JURISDICTION,
    SET_JURISDICTION_BY_CODE
} from '../../jurisdiction/redux/actionTypes';
import { FETCH_USERS } from '../../main/main-content/team/user/redux/user-list/actionTypes';
import { FETCH_TEAMS } from '../../main/main-content/team/teams/redux/teams-list/actionTypes';
import {
    ADD_USER_TO_TEAM,
    REMOVE_USER_FROM_TEAM,
    UPDATE_USER
} from '../../main/main-content/team/user/redux/update-user/actionTypes';
import { fetchUsersSaga } from '../../main/main-content/team/user/redux/user-list/sagas';
import { fetchTeamsSaga } from '../../main/main-content/team/teams/redux/teams-list/sagas';
import {
    addUserToTeamSaga,
    removeUserFromTeamSaga,
    updateUserSaga
} from '../../main/main-content/team/user/redux/update-user/sagas';
import { fetchTeamDetailsSaga } from '../../main/main-content/team/teams/redux/team-details/sagas';
import { FETCH_TEAM_DETAILS } from '../../main/main-content/team/teams/redux/team-details/actionTypes';
import { FETCH_USER_DETAILS } from '../../main/main-content/team/user/redux/user-details/actionTypes';
import { fetchUserDetailsSaga } from '../../main/main-content/team/user/redux/user-details/sagas';
import { ADD_TEAM } from '../../main/main-content/team/teams/redux/add-team/actionTypes';
import { addTeamSaga } from '../../main/main-content/team/teams/redux/add-team/sagas';
import {
    addPermissionToTeamSaga,
    deletePermissionFromTeamSaga
} from '../../main/main-content/team/teams/redux/permissions/sagas';
import {
    ADD_PERMISSION_TO_TEAM,
    DELETE_PERMISSION_FROM_TEAM
} from '../../main/main-content/team/teams/redux/permissions/actionTypes';
import { editTeamSaga } from '../../main/main-content/team/teams/redux/edit-team/sagas';
import { EDIT_TEAM } from '../../main/main-content/team/teams/redux/edit-team/actionTypes';
import {
    ADD_BRAND_TO_TEAM,
    ADD_JURISDICTION_TO_TEAM,
    DELETE_BRAND_FROM_TEAM,
    DELETE_JURISDICTION_FROM_TEAM
} from '../../main/main-content/team/teams/redux/jurisdictions/actionTypes';
import {
    addBrandToTeamSaga,
    addJurisdictionToTeamSaga,
    deleteBrandFromTeamSaga,
    deleteJurisdictionFromTeamSaga
} from '../../main/main-content/team/teams/redux/jurisdictions/sagas';
import {
    DELEGATE_ALERT,
    FETCH_DELEGATE_TEAMS
} from '../../main/main-content/alerts/delegate/redux/actionTypes';
import {
    delegateAlertSaga,
    fetchDelegateTeamsSaga
} from '../../main/main-content/alerts/delegate/redux/sagas';
import { CREATE_USER } from '../../main/main-content/team/user/create-user/redux/actionTypes';
import { createUserSaga } from '../../main/main-content/team/user/create-user/redux/sagas';
import { FORGOT_PASSWORD } from '../../auth/reset-password/redux/actionTypes';
import { forgotPasswordSaga } from '../../auth/reset-password/redux/sagas';
import { FETCH_HELP } from '../../main/main-content/help/redux/actionTypes';
import { fetchHelpSaga } from '../../main/main-content/help/redux/sagas';
import { EXPORT_CSV_ALERTS } from '../../main/main-content/export-csv/redux/actionTypes';
import { exportCsvAlertsSaga } from '../../main/main-content/export-csv/redux/sagas';

export default function* rootSaga() {
    yield takeEvery(DISMISS_ALERT, dismissAlertSaga);
    yield takeEvery(DELEGATE_ALERT, delegateAlertSaga);
    yield takeEvery(FETCH_DELEGATE_TEAMS, fetchDelegateTeamsSaga);
    yield takeEvery(FETCH_ALERTS, fetchAlertsSaga);
    yield takeEvery(FETCH_EVENTS, fetchEventsSaga);
    yield takeEvery(FETCH_JURISDICTIONS, fetchJurisdictionsSaga);
    yield takeEvery(
        FETCH_NUMBER_OF_ACTIVE_PLAYERS,
        fetchNumberOfActivePlayersSaga
    );
    yield takeEvery(
        FETCH_NUMBER_OF_EVENTS_FOR_THE_LAST_DAY,
        fetchNumberOfEventsForTheLastDaySaga
    );
    yield takeEvery(FETCH_NUMBER_OF_PLAYERS, fetchNumberOfPlayersSaga);
    yield takeEvery(
        FETCH_NUMBER_OF_PLAYERS_WITH_OPEN_ALERTS,
        fetchNumberOfPlayersWithOpenAlertsSaga
    );
    yield takeEvery(
        FETCH_OPEN_ALERTS_PER_RULE_CATEGORY,
        fetchOpenAlertsPerRuleCategorySaga
    );
    yield takeEvery(FETCH_OVERALL_SYSTEM_RISK, fetchOverallSystemRiskSaga);
    yield takeEvery(FETCH_PLAYER_ALERTS, fetchPlayerAlertsSaga);
    yield takeEvery(FETCH_PLAYER_DETAILS, fetchPlayerDetailsSaga);
    yield takeEvery(FETCH_PLAYER_EVENTS, fetchPlayerEventsSaga);
    yield takeEvery(FETCH_PLAYERS, fetchPlayersSaga);
    yield takeEvery(
        FETCH_REGISTRATIONS_PER_MONTH,
        fetchRegistrationsPerMonthSaga
    );
    yield takeEvery(FETCH_RISK_CONFIG, fetchRiskConfigSaga);
    yield takeEvery(FETCH_RULES, fetchRulesSaga);
    yield takeLatest(FETCH_STATS, fetchStatsSaga);
    yield takeEvery(FETCH_TOP_RISKY_PLAYERS, fetchTopRiskyPlayersSaga);
    yield takeEvery(FETCH_WORLDMAP, fetchWorldmapSaga);
    yield takeEvery(LOGIN, loginSaga);
    yield takeEvery(FORGOT_PASSWORD, forgotPasswordSaga);
    yield takeEvery(FETCH_USER_PERMISSIONS, fetchUserPermissionsSaga);
    yield takeEvery(SET_TOAST_ERROR, setToastErrorSaga);
    yield takeEvery(SET_TOAST_SUCCESS, setToastSuccessSaga);
    yield takeEvery(UPDATE_RISK_CONFIG, updateRiskConfigSaga);
    yield takeEvery(UPDATE_RULE, updateRuleSaga);
    yield takeEvery(UPDATE_RULE_STATUS, updateRuleStatusSaga);
    yield takeEvery(FETCH_USERS, fetchUsersSaga);
    yield takeEvery(FETCH_USER_DETAILS, fetchUserDetailsSaga);
    yield takeEvery(FETCH_TEAMS, fetchTeamsSaga);
    yield takeEvery(FETCH_TEAM_DETAILS, fetchTeamDetailsSaga);
    yield takeEvery(ADD_TEAM, addTeamSaga);
    yield takeEvery(EDIT_TEAM, editTeamSaga);
    yield takeEvery(ADD_PERMISSION_TO_TEAM, addPermissionToTeamSaga);
    yield takeEvery(DELETE_PERMISSION_FROM_TEAM, deletePermissionFromTeamSaga);
    yield takeEvery(ADD_JURISDICTION_TO_TEAM, addJurisdictionToTeamSaga);
    yield takeEvery(
        DELETE_JURISDICTION_FROM_TEAM,
        deleteJurisdictionFromTeamSaga
    );
    yield takeEvery(ADD_BRAND_TO_TEAM, addBrandToTeamSaga);
    yield takeEvery(DELETE_BRAND_FROM_TEAM, deleteBrandFromTeamSaga);
    yield takeEvery(UPDATE_USER, updateUserSaga);
    yield takeEvery(ADD_USER_TO_TEAM, addUserToTeamSaga);
    yield takeEvery(REMOVE_USER_FROM_TEAM, removeUserFromTeamSaga);

    yield takeEvery(SET_JURISDICTION, setJurisdictionSaga);
    yield takeEvery(SET_JURISDICTION_BY_CODE, setJurisdictionByCodeSaga);
    yield takeEvery(CREATE_USER, createUserSaga);
    yield takeEvery(FETCH_HELP, fetchHelpSaga);
    yield takeEvery(EXPORT_CSV_ALERTS, exportCsvAlertsSaga);

    /* Access and audit. */
    yield takeLatest(FETCH_CLIENT_CREDENTIALS, fetchClientCredentialsSaga);
    yield takeEvery(SET_CLIENT_BRANDS, setClientBrandsSaga);
    yield takeLatest(FETCH_AUDIT_EVENTS, fetchAuditEventsSaga);
    yield takeLatest(FETCH_AUDIT_USERS, fetchAuditUsersSaga);

    /* Simulation. */
    yield takeLatest(FETCH_WORKSPACES, fetchWorkspacesSaga);
    yield takeEvery(CREATE_WORKSPACE, createWorkspaceSaga);
    yield takeEvery(REFRESH_WORKSPACE, refreshWorkspaceSaga);
    yield takeEvery(RESET_WORKSPACE, resetWorkspaceSaga);
    yield takeEvery(DELETE_WORKSPACE, deleteWorkspaceSaga);
    yield takeLatest(FETCH_RUNS, fetchRunsSaga);
    yield takeLatest(FETCH_SCENARIOS, fetchScenariosSaga);
    yield takeLatest(FETCH_SIMULATION_LIMITS, fetchSimulationLimitsSaga);
    yield takeEvery(CREATE_RUN, createRunSaga);
    yield takeLatest(FOLLOW_RUN, watchFollowRunSaga);
    yield takeLatest(FOLLOW_RUNS_LIST, watchFollowRunsListSaga);
    yield takeLatest(FETCH_RUN_TO_COPY, fetchRunToCopySaga);
    yield takeEvery(CANCEL_RUN, cancelRunSaga);
    yield takeEvery(DELETE_RUN, deleteRunSaga);
    yield takeLatest(FETCH_WORKSPACE_CONFIG, fetchWorkspaceConfigSaga);
    yield takeEvery(START_COMPARISON, startComparisonSaga);
    yield takeLatest(FOLLOW_COMPARISON, watchFollowComparisonSaga);
    yield takeLatest(FETCH_COMPARISON, fetchComparisonSaga);
}
